import React, { Suspense } from 'react';
import { Outlet } from 'react-router';

function AuthPageFallback() {
  return <div style={{ minHeight: '100vh' }} aria-busy="true" aria-label="Loading page" />;
}

export default function Withoutnav() {
  return (
    <Suspense fallback={<AuthPageFallback />}>
      <Outlet />
    </Suspense>
  );
}